export enum FormShipmentTypes {
	LoadForm = "LoadForm",
	UnLoadForm = "UnLoadForm",
    None = "None"
}
